import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { useWallets } from "../../../context/wallets";
import classNames from "../../../utils/classNames";

interface Props {
  className?: string;
  walletAddress: string;
  bigSize?: boolean;
}

const WalletVerificationCountdown: React.FC<Props> = ({
  className,
  walletAddress,
  bigSize
}) => {
  const { getActiveWalletVerification } = useWallets();
  const [secondsToExpiry, setSecondsToExpiry] = useState(24 * 60);

  const activeWalletVerification = useMemo(
    () => getActiveWalletVerification(walletAddress),
    [getActiveWalletVerification, walletAddress]
  );

  useEffect(() => {
    if (!activeWalletVerification?.expires_at) return;

    setSecondsToExpiry(
      moment(activeWalletVerification.expires_at)
        .utc()
        .diff(moment().utc(), "seconds")
    );

    const timer = setInterval(
      () => setSecondsToExpiry((prev) => prev - 1),
      1000
    );

    return () => {
      clearInterval(timer);
    };
  }, [activeWalletVerification?.expires_at]);

  if (!activeWalletVerification) {
    return null;
  }

  return (
    <div
      className={classNames(
        "grid grid-flow-col gap-5 text-center auto-cols-max",
        className
      )}
    >
      <div className="flex flex-col">
        <span
          className={classNames("font-mono", bigSize ? "text-5xl" : "text-xl")}
        >
          {getHMS(secondsToExpiry).h}
        </span>
        hours
      </div>
      <div className="flex flex-col">
        <span
          className={classNames("font-mono", bigSize ? "text-5xl" : "text-xl")}
        >
          {getHMS(secondsToExpiry).m}
        </span>
        min
      </div>
      <div className="flex flex-col">
        <span
          className={classNames("font-mono", bigSize ? "text-5xl" : "text-xl")}
        >
          {getHMS(secondsToExpiry).s}
        </span>
        sec
      </div>
    </div>
  );
};

export default WalletVerificationCountdown;

//
// Utils
//

const getHMS = (timeInSeconds: number) => {
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds - hours * 3600) / 60);
  const seconds = timeInSeconds - hours * 3600 - minutes * 60;

  let hoursString = hours < 10 ? `0${hours}` : `${hours}`;
  let minutesString = minutes < 10 ? `0${minutes}` : `${minutes}`;
  let secondsString = seconds < 10 ? `0${seconds}` : `${seconds}`;

  return { h: hoursString, m: minutesString, s: secondsString };
};
